import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Navigation } from '../partials/header';
import { NotLoggedIn } from '../partials/notLoggedIn'; // 1. Add this import
import { useUser } from '../app';
import '../theme.css'; 

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const BACKEND_URI = IS_PRODUCTION ? process.env.REACT_APP_API_BASE_URI : "http://localhost:5050";

function CalendarDashboard() {
    const [calendars, setCalendars] = useState([]);
    const navigate = useNavigate();
    const { user, loading } = useUser();

    useEffect(() => {
        document.title = "My Farms";
        
        // Only fetch if user exists
        if (user && user.username) {
            fetch(`${BACKEND_URI}/calendars/${user.username}`, { credentials: 'include' })
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
                    }
                    return res.json();
                })
                .then(data => setCalendars(data))
                .catch(err => {
                    console.error("Error fetching calendars:", err);
                    setCalendars([]); // Reset to empty array on error
                });
        }
    }, [user]); // 2. FIXED: Changed [user.username] to [user] to prevent crash

    const handleCreateNew = () => {
        navigate('/calendar/new');
    };

    const handleLoad = (calendarId) => {
        navigate(`/calendar/${calendarId}`);
    };

    // 3. Add the Not Logged In check
    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        return (
            <div>
                <NotLoggedIn />
            </div>
        );
    }

    return (
        <div className="theme-container">
            <Navigation />

            <div className="main-content">
                <Header />

                <div className="page-content">
                    <div className="content-wrapper">
                        <h1 className="page-heading">My Farms</h1>
                        
                        <div className="dashboard-grid">
                            {/* Create New Card */}
                            <div className="calendar-card create-card" onClick={handleCreateNew}>
                                <div className="plus-icon">+</div>
                                <h3>Start New Farm</h3>
                            </div>

                            {/* Existing Calendars */}
                            {calendars.map(cal => (
                                <div key={cal._id} className="calendar-card" onClick={() => handleLoad(cal._id)}>
                                    <h3>{cal.name}</h3>
                                    <img src={`/images/${cal.imgLink}.png`} alt="Calendar Icon" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CalendarDashboard;